import React from "react";
import "./Home.css";
import HomeSection2 from "./HomeSection2";
import HomeSection3 from "./HomeSection3";
import HomeSection4 from "./HomeSection4";
import Layout from "../../components/Layout";
import HomeSection1new from "./HomeSection1new";
import ServicesSection from "./ServicesSection";
import WhyChooseUs from "./WhyChooseUs";
import Testimonials from "./Testimonails";
import FAQ from "./FAQ";
import Map from "./Map";

const MainHome = () => {
  return (
    <Layout title={"MBA Solutions - Home"} >


      <div className="bg-[#F2F2F2] overflow-x-hidden">
        <HomeSection1new />
        {/* <HomeSection2 /> old section  */}
        <ServicesSection />
        {/* <HomeSection4 /> */}
        <WhyChooseUs />
        {/* <HomeSection3 /> */}
        <Testimonials />
        <FAQ />
        <Map />
      </div>

    </Layout>
  );
};

export default MainHome;
